(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-catalog"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root    = document.getElementById('b2b-view-collections');
  var backBtn = document.getElementById('b2b-back');
  var bcLabel = document.getElementById('b2b-breadcrumb-label');
  var bcSep   = document.getElementById('b2b-breadcrumb-sep');

  if (!root) return;

  var TARGET    = ['M', 'L', 'XL', '2XL'];
  var curHandle = null;
  var cache     = Object.create(null);

  function esc(s) {
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function imgUrl(src, w) {
    if (!src) return '';
    return src.replace(/\.(jpg|jpeg|gif|png|webp)(\?.*)?$/i, function (_, ext, qs) {
      return '_' + w + 'x.' + ext + (qs || '');
    });
  }

  function sizesFor(product) {
    var found = {};
    (product.variants || []).forEach(function (v) {
      if (!v.available) return;
      [v.option1, v.option2, v.option3].forEach(function (o) {
        if (o && TARGET.indexOf(o) !== -1) found[o] = true;
      });
    });
    return TARGET.filter(function (s) { return found[s]; });
  }

  function cardHtml(product) {
    var sizes  = sizesFor(product);
    var src    = product.images && product.images[0] ? imgUrl(product.images[0].src, 480) : '';
    var imgTag = src
      ? '<img src="' + esc(src) + '" alt="' + esc(product.title) + '" class="b2b-card__img" loading="lazy" width="480" height="640">'
      : '<span class="b2b-card__img b2b-card__img--placeholder"></span>';
    return '<article class="b2b-card">' +
      '<a href="/products/' + esc(product.handle) + '" class="b2b-card__inner">' +
        '<div class="b2b-card__img-wrap">' + imgTag + '</div>' +
        '<div class="b2b-card__info">' +
          '<h3 class="b2b-card__name">' + esc(product.title) + '</h3>' +
          '<div class="b2b-card__sizes">' +
            sizes.map(function (s) { return '<span class="b2b-card__size">' + esc(s) + '</span>'; }).join('') +
          '</div>' +
        '</div>' +
      '</a></article>';
  }

  function fetchAll(handle, page, acc, done) {
    fetch('/collections/' + handle + '/products.json?limit=250&page=' + page)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var batch = d.products || [];
        var all   = acc.concat(batch);
        batch.length === 250 ? fetchAll(handle, page + 1, all, done) : done(all);
      })
      .catch(function () { done(acc); });
  }

  function renderPage(grid, products, perPage, page) {
    var total = products.length;
    var pages = Math.ceil(total / perPage) || 1;
    page = Math.max(1, Math.min(page, pages));

    var slice = products.slice((page - 1) * perPage, page * perPage);
    var html  = slice.length
      ? slice.map(cardHtml).join('')
      : '<p class="b2b-empty">No products found.</p>';

    if (pages > 1) {
      html += '<div class="b2b-pager">' +
        '<button class="b2b-pager__btn" data-page="' + (page - 1) + '"' + (page === 1 ? ' disabled' : '') + '>← Previous</button>' +
        '<span class="b2b-pager__info">Page ' + page + ' of ' + pages + '</span>' +
        '<button class="b2b-pager__btn" data-page="' + (page + 1) + '"' + (page === pages ? ' disabled' : '') + '>Next →</button>' +
      '</div>';
    }

    grid.innerHTML = html;

    grid.querySelectorAll('.b2b-pager__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        renderPage(grid, products, perPage, parseInt(btn.dataset.page, 10));
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
  }

  function loadCollection(handle) {
    var grid    = document.getElementById('b2b-grid-' + handle);
    if (!grid) return;
    var perPage = parseInt(grid.dataset.perPage, 10) || 24;

    if (cache[handle]) {
      renderPage(grid, cache[handle], perPage, 1);
      return;
    }

    grid.innerHTML = '<p class="b2b-loading">Loading…</p>';

    fetchAll(handle, 1, [], function (products) {
      cache[handle] = products.filter(function (p) { return sizesFor(p).length >= 3; });
      renderPage(grid, cache[handle], perPage, 1);
    });
  }

  function getPanel(h) { return document.getElementById('b2b-col-' + h); }

  function hideAll() {
    document.querySelectorAll('.b2b-products-view').forEach(function (p) { p.hidden = true; });
  }

  function openCollection(handle) {
    var panel = getPanel(handle);
    if (!panel) return;

    hideAll();
    root.hidden  = true;
    panel.hidden = false;
    curHandle    = handle;

    loadCollection(handle);

    var btn   = root.querySelector('[data-handle="' + handle + '"]');
    var title = btn ? ((btn.querySelector('.b2b-coll-card__title') || {}).textContent || '').trim() : '';

    if (bcLabel) bcLabel.textContent = title;
    if (backBtn) backBtn.hidden      = false;
    if (bcSep)   bcSep.hidden        = false;

    history.pushState({ collection: handle }, '', '#' + handle);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function openCollections() {
    hideAll();
    root.hidden = false;
    curHandle   = null;

    if (bcLabel) bcLabel.textContent = '';
    if (backBtn) backBtn.hidden      = true;
    if (bcSep)   bcSep.hidden        = true;

    history.pushState({}, '', window.location.pathname);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  root.addEventListener('click', function (e) {
    var card = e.target.closest('.b2b-coll-card');
    if (card) openCollection(card.dataset.handle);
  });

  if (backBtn) backBtn.addEventListener('click', openCollections);

  window.addEventListener('popstate', function (e) {
    if (e.state && e.state.collection) openCollection(e.state.collection);
    else openCollections();
  });

  var hash = window.location.hash.slice(1);
  if (hash) openCollection(hash);
})();

  } catch(e) { console.error(e); }
})();
})();
